export const CHANGED_LANGUAGE_SUCCESS = 'CHANGED_LANGUAGE_SUCCESS';
export const CHANGED_LANGUAGE_ERROR = 'CHANGED_LANGUAGE_ERROR';

export interface ReceiveChangedLanguageSuccessAction {
    type: typeof CHANGED_LANGUAGE_SUCCESS;
    payload: { changedLanguageSuccess: boolean };
}
export interface ReceiveChangedLanguageWithErrorAction {
    type: typeof CHANGED_LANGUAGE_ERROR;
    error: Error;
}
export type UserSettingsActionTypes = ReceiveChangedLanguageSuccessAction | ReceiveChangedLanguageWithErrorAction;
